import { useLocation } from 'react-router-dom';
import { Warning } from '@mui/icons-material';
import { Box, Card, ListItem } from '@mui/material';
import { DesktopLayout } from '/src/layouts';

export const PageNotFound: React.FC = () => {
  /** Context **/
  const location = useLocation();

  /** Render **/
  return (
    <DesktopLayout>
      <Box display="flex" justifyContent="center" alignItems="center">
        <Card component="md-card">
          <Box className="toolbar-div" display="flex" justifyContent="center" alignItems="center" gap="6px">
            <Warning className="material-icons md-icon" />
            <Box component="span" className="thin md-display-1">
              Page Not Found
            </Box>
          </Box>
          <ListItem sx={{ bgcolor: 'white' }}>
            <pre>{location.pathname} is not a valid path.</pre>
          </ListItem>
        </Card>
      </Box>
    </DesktopLayout>
  );
};
